"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LocusMediaRequest = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _lodash = require("lodash");
var _common = require("@webex/common");
var _webexCore = require("@webex/webex-core");
var _constants = require("../constants");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable valid-jsdoc */
/** Class representing a single /media request being sent to Locus */
var InternalRequestInfo = /*#__PURE__*/function () {
  /** Constructor */
  function InternalRequestInfo(request, pendingPromise, sendRequestFn) {
    (0, _classCallCheck2.default)(this, InternalRequestInfo);
    (0, _defineProperty2.default)(this, "request", void 0);
    (0, _defineProperty2.default)(this, "pendingPromises", void 0);
    (0, _defineProperty2.default)(this, "sendRequestFn", void 0);
    this.request = request;
    this.pendingPromises = [pendingPromise];
    this.sendRequestFn = sendRequestFn;
  }

  /**
   * Returns the list of pending promises associated with this request
   */
  (0, _createClass2.default)(InternalRequestInfo, [{
    key: "getPendingPromises",
    value: function getPendingPromises() {
      return this.pendingPromises;
    }

    /**
     * Adds promises to the list of pending promises associated with this request
     */
  }, {
    key: "addPendingPromises",
    value: function addPendingPromises(pendingPromises) {
      var _this$pendingPromises;
      (_this$pendingPromises = this.pendingPromises).push.apply(_this$pendingPromises, (0, _toConsumableArray2.default)(pendingPromises));
    }

    /**
     * Executes the request. Returned promise is resolved once the request
     * is completed (no matter if it succeeded or failed).
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this = this;
      return this.sendRequestFn(this.request).then(function (result) {
        // resolve all the pending promises associated with this request
        _this.pendingPromises.forEach(function (d) {
          return d.resolve(result);
        });
      }).catch(function (e) {
        // reject all the pending promises associated with this request
        _this.pendingPromises.forEach(function (d) {
          return d.reject(e);
        });
      });
    }
  }]);
  return InternalRequestInfo;
}();
/**
 * Returns true if the request is triggering confluence creation in the server
 */
function isRequestAffectingConfluenceState(request) {
  return request.type === 'RoapMessage' && request.roapMessage.messageType === _constants.ROAP.ROAP_TYPES.OFFER;
}

/**
 * This class manages all /media API requests to Locus. Every call to that
 * Locus API has to go through this class.
 */
var LocusMediaRequest = exports.LocusMediaRequest = /*#__PURE__*/function (_WebexPlugin) {
  (0, _inherits2.default)(LocusMediaRequest, _WebexPlugin);
  var _super = _createSuper(LocusMediaRequest);
  /**
   * Constructor
   */
  function LocusMediaRequest(config, options) {
    var _this2;
    (0, _classCallCheck2.default)(this, LocusMediaRequest);
    _this2 = _super.call(this, {}, options);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "config", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "latestAudioMuted", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "latestVideoMuted", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "isRequestInProgress", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "queuedRequests", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "confluenceState", void 0);
    _this2.isRequestInProgress = false;
    _this2.queuedRequests = [];
    _this2.config = config;
    _this2.confluenceState = 'not created';
    return _this2;
  }

  /**
   * Add a request to the internal queue.
   */
  (0, _createClass2.default)(LocusMediaRequest, [{
    key: "addToQueue",
    value: function addToQueue(info) {
      if (info.request.type === 'LocalMute' && this.queuedRequests.length > 0) {
        // We don't need additional local mute requests in the queue.
        // We only need at most 1 local mute or 1 roap request, because
        // roap requests also include mute state, so whatever request
        // is sent out, it will send the latest local mute state.
        // We only need to store the pendingPromises so that they get resolved
        // when the roap request is sent out.
        this.queuedRequests[0].addPendingPromises(info.getPendingPromises());
        return;
      }
      if (info.request.type === 'RoapMessage' && this.queuedRequests.length > 0) {
        // remove any LocalMute requests from the queue, because this Roap message
        // will also update the mute status in Locus, so they are redundant
        this.queuedRequests = this.queuedRequests.filter(function (r) {
          if (r.request.type === 'LocalMute') {
            // we need to keep the pending promises from the local mute request
            // that we're removing from the queue
            info.addPendingPromises(r.getPendingPromises());
            return false;
          }
          return true;
        });
      }
      this.queuedRequests.push(info);
    }

    /**
     * Takes the next request from the queue and executes it. Once that
     * request is completed, the next one will be taken from the queue
     * and executed and this is repeated until the queue is empty.
     */
  }, {
    key: "executeNextQueuedRequest",
    value: function executeNextQueuedRequest() {
      var _this3 = this;
      if (this.isRequestInProgress) {
        return;
      }
      var nextRequest = this.queuedRequests.shift();
      if (nextRequest) {
        this.isRequestInProgress = true;
        nextRequest.execute().then(function () {
          _this3.isRequestInProgress = false;
          _this3.executeNextQueuedRequest();
        });
      }
    }

    /**
     * Returns latest requested audio and video mute values. If they have never been
     * requested, we assume audio/video to be muted.
     */
  }, {
    key: "getLatestMuteState",
    value: function getLatestMuteState() {
      var audioMuted = this.latestAudioMuted !== undefined ? this.latestAudioMuted : true;
      var videoMuted = this.latestVideoMuted !== undefined ? this.latestVideoMuted : true;
      return {
        audioMuted: audioMuted,
        videoMuted: videoMuted
      };
    }

    /**
     * Prepares the uri and body for the media request to be sent to Locus
     */
  }, {
    key: "sendHttpRequest",
    value: function sendHttpRequest(request) {
      var _this4 = this;
      var uri = "".concat(request.selfUrl, "/").concat(_constants.MEDIA);
      var _this$getLatestMuteSt = this.getLatestMuteState(),
        audioMuted = _this$getLatestMuteSt.audioMuted,
        videoMuted = _this$getLatestMuteSt.videoMuted;

      // first setup things common to all requests
      var body = {
        device: this.config.device,
        correlationId: this.config.correlationId
      };
      var localMedias = {
        audioMuted: audioMuted,
        videoMuted: videoMuted
      };

      // now add things specific to request type
      switch (request.type) {
        case 'LocalMute':
          body.respOnlySdp = true;
          body.usingResource = null;
          break;
        case 'RoapMessage':
          localMedias.roapMessage = request.roapMessage;
          localMedias.reachability = request.reachability;
          body.clientMediaPreferences = request.clientMediaPreferences;

          // @ts-ignore
          this.webex.internal.newMetrics.submitClientEvent({
            name: 'client.locus.media.request',
            options: {
              meetingId: this.config.meetingId
            }
          });
          break;
      }
      if (request.sequence) {
        body.sequence = request.sequence;
      }
      body.localMedias = [{
        localSdp: (0, _stringify.default)(localMedias),
        // this part must be JSON stringified, Locus requires this
        mediaId: request.mediaId
      }];
      _loggerProxy.default.logger.info("Meeting:LocusMediaRequest#sendHttpRequest --> ".concat(request.type, " audioMuted=").concat(audioMuted, " videoMuted=").concat(videoMuted));
      if (isRequestAffectingConfluenceState(request) && this.confluenceState === 'not created') {
        this.confluenceState = 'creation in progress';
      }

      // @ts-ignore
      return this.request({
        method: _constants.HTTP_VERBS.PUT,
        uri: uri,
        body: body
      }).then(function (result) {
        if (isRequestAffectingConfluenceState(request)) {
          _this4.confluenceState = 'created';
        }
        if (request.type === 'RoapMessage') {
          // @ts-ignore
          _this4.webex.internal.newMetrics.submitClientEvent({
            name: 'client.locus.media.response',
            options: {
              meetingId: _this4.config.meetingId
            }
          });
        }
        return result;
      }).catch(function (e) {
        if (isRequestAffectingConfluenceState(request) && _this4.confluenceState === 'creation in progress') {
          _this4.confluenceState = 'not created';
        }
        if (request.type === 'RoapMessage') {
          // @ts-ignore
          _this4.webex.internal.newMetrics.submitClientEvent({
            name: 'client.locus.media.response',
            options: {
              meetingId: _this4.config.meetingId,
              rawError: e
            }
          });
        }
        throw e;
      });
    }

    /**
     * Sends a media request to Locus
     */
  }, {
    key: "send",
    value: function send(request) {
      var _this5 = this;
      if (request.type === 'LocalMute') {
        var _request$muteOptions = request.muteOptions,
          audioMuted = _request$muteOptions.audioMuted,
          videoMuted = _request$muteOptions.videoMuted;
        if (audioMuted !== undefined) {
          this.latestAudioMuted = audioMuted;
        }
        if (videoMuted !== undefined) {
          this.latestVideoMuted = videoMuted;
        }
        if (this.confluenceState === 'not created') {
          // if there is no confluence, there is no point sending out local mute request
          // as it will fail so we just store the latest audio/video muted values
          // and resolve immediately, so that higher layer (MuteState class) doesn't get blocked
          // and can call us again if user mutes/unmutes again before confluence is created
          _loggerProxy.default.logger.info('Meeting:LocusMediaRequest#send --> called with LocalMute request before confluence creation');
          return _promise.default.resolve({});
        }
      }
      var pendingPromise = new _common.Defer();
      var newRequest = new InternalRequestInfo(request, pendingPromise, this.sendHttpRequest.bind(this));
      this.addToQueue(newRequest);
      (0, _lodash.defer)(function () {
        return _this5.executeNextQueuedRequest();
      });
      return pendingPromise.promise;
    }

    /** Returns true if a confluence on the server is already created */
  }, {
    key: "isConfluenceCreated",
    value: function isConfluenceCreated() {
      return this.confluenceState === 'created';
    }

    /**
     * This method needs to be called when we downgrade from multistream to transcoded connection.
     */
  }, {
    key: "downgradeFromMultistreamToTranscoded",
    value: function downgradeFromMultistreamToTranscoded() {
      this.config.preferTranscoding = true;
    }
  }]);
  return LocusMediaRequest;
}(_webexCore.WebexPlugin);
//# sourceMappingURL=locusMediaRequest.js.map
